import './main.less';
import React from 'react';
import PropTypes from 'prop-types';

const Timeline = props => {
	const { survey, intl } = props;
	return !!survey && (
		<div className="survey-container">
			<div className="survey-item">
				<div className="survey-item-title">{intl('Locations')}:</div>
				<div className="survey-item-value">{survey.locations.join(', ')}</div>
			</div>
			<div className="survey-item">
				<div className="survey-item-title">{intl('Traffic sources')}:</div>
				<div className="survey-item-value">{survey.trafficSources.join(', ')}</div>
			</div>
			<div className="survey-item">
				<div className="survey-item-title">{intl('Niches')}:</div>
				<div className="survey-item-value">{survey.niches.join(', ')}</div>
			</div>
			{
				survey.experience &&
				<div className="survey-item">
					<div className="survey-item-title">{intl('Experience')}:</div>
					<div className="survey-item-value">{survey.experience}</div>
				</div>
			}
			{
				survey.budget &&
				<div className="survey-item">
					<div className="survey-item-title">{intl('Budget')}:</div>
					<div className="survey-item-value">{survey.budget}</div>
				</div>
			}
			{
				survey.leadsDaily &&
				<div className="survey-item">
					<div className="survey-item-title">{intl('Leads daily')}:</div>
					<div className="survey-item-value">{survey.leadsDaily}</div>
				</div>
			}
		</div>
	);
};

Timeline.propTypes = {
	logs: PropTypes.object,
	showMoreLogs: PropTypes.func,
	intl: PropTypes.func
};

export default Timeline;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/survey/main.js